import React, { useState, useEffect } from 'react'
import { Formik } from 'formik'
import { CircularProgress } from '@material-ui/core'
import Axios from 'axios'

import { TextFieldIcon, Button, TopBar } from '../_components'
import NITALogo from '../_images/nita_logo.svg'
import UGPassLogo from '../_images/UgPass.png'
import { FaLock, FaUserAlt } from 'react-icons/fa'

import useFetchUghubToken from '../_hooks/useFetchUghubToken'


export default function SignIn( { changePassword } ) {
  const [ signing, setSigning ] = useState( false )
  const [ submitting, setSubmitting ] = useState( false )
  const [ loading, setLoading ] = useState( true )
  const [ displayMessage, setDisplayMessage ] = useState( "" )
  const [ emailValue, setEmailValue] = useState("");

  const [ fetchedToken, setToken  ] = useState( null )

  const getToken = useFetchUghubToken()

  useEffect( () => {
    if( loading ) {
      handleApp()
    }
  }, [ loading ])

  useEffect( () => {
    if( localStorage.getItem( "link" ) === "welcome" ) {
    }
  }, [ localStorage.getItem( "link" ) ] )

  const handleApp = async () => {

      const location = window.location 
      const url = new URL( location )
      const state = url?.searchParams.get( "state" )
      let code = url?.searchParams.get( "code" )
      const storedState = localStorage.getItem( "state" )
      const error = url?.searchParams.get( "error" )
      const error_description = url?.searchParams.get( "error_description" )
      //console.log("in the handle app method")
      //console.log("stored state "+storedState)
      //console.log("error is "+error)

      if( error ) {
        setLoading( false )
        alert ( error_description ) 
        window.location.href = "https://cert.works.go.ug"
        return
      }

      // if( !error && storedState && storedState?.length > 0 && code  ) {
      //   await localStorage.setItem( "code", code  ) 
      //   alert( "The Application login was successful with UgPass" )

      //   window.location.replace( "https://cert.works.go.ug" )
      
      //   //await localStorage.removeItem( "state" )

      //   await localStorage.setItem( "link", "ugpass_validate"  )
      //   setLoading( false )
      //   return
      // }

      if( !error && storedState && storedState?.length > 0  ) {
        await localStorage.setItem( "code", code  ) 
        alert( "The Application login was successful with UgPass" )

        window.location.replace( "https://cert.works.go.ug" )
      
        //await localStorage.removeItem( "state" )

        await localStorage.setItem( "link", "ugpass_validate"  )
        setLoading( false )
        return
      }
  }

  const handleSubmitUgPass = async () => {
    let url = `https://auth.cert.works.go.ug/api`
    await setSubmitting( true )
    try {
      // const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/handover_to_ugpass` )
      const response = await Axios.get( `${url}/generateAuthUrl` )
      if( response.data ) {
        //console.log(response.data)
         //const { url, state } = response.data
         const url = response.data.url
         const state = response.data.state

         await localStorage.setItem( "state",state )
         await localStorage.setItem( "ugpass_access", true )
         //redirection
         window.location.href = url
         await setSubmitting( false )
      }
    } catch (error) {
      console.log( error )
      await setSubmitting( false )
      // alert( "Could not connect to UgPass" )
    }
  }

  const handleSubmitUgPassSASignIn = async( values ) => {
    await setSigning( true )
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/ugpass/authenticate`)
      //const response = await Axios.get( `https://api.cert.works.go.ug/api/auth/ugpass/authenticate`)

      if(response.data.url){
        //do the redirection to the ugpass page
        await localStorage.setItem( "state", response.data.state )
        await localStorage.setItem( "ugpass_access", true )
        await setSubmitting( false )
        window.location.href = response.data.url;
      } else{
        //console.log("below is the response")
        //console.log(response.data)
        alert("UgPass authentication failed")
      }
      
      // if( response.data.user_info ) {
      //   console.log("returned data")
      //   console.log(response.data)
      //   await localStorage.setItem( "link", "ugpass_validate"  )
      //   return window.location.reload();
      // } else{
      //   console.log("below is the response")
      //   console.log(response.data)
      //   alert("UgPass authentication failed")
      // }
    } catch (error) {
      console.log("failed to login with UgPass service Agent")
      console.log( error )
      await setSubmitting( false )
      // alert( "Could not connect to UgPass" )
    }
  }

  const handleSubmit = async( values ) => {
    await setSigning( true )
    try {
      const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/login_user`, {
        email: values.email,
        password: values.password
      })
      
      if( response.data.success === true ) {
        await localStorage.setItem( "email", response.data.record.email_address )
        await localStorage.setItem( "userId", response.data.record.id )
        await localStorage.setItem( "username", response.data.record.email_address )
        await localStorage.setItem( "role", response.data.record.user_role )
        await localStorage.setItem( "domain", response.data.record.domain )
        const token = response.data.token;
        await localStorage.setItem( "token", token )
        //await localStorage.setItem( "token_type", response.data.token_type )
        //await localStorage.setItem( "expires_in", response.data.expires_in )

        if( response.data.otp ) {
          await setDisplayMessage( "An OTP has been sent to your email. Please use the sent password and your email to login" )
          alert("A one time password has been sent to your email. Use it to login");
          await setSigning( false )
          return;
          //return window.location.reload()
        }
        

        if( response.data.record.login_status !== 1) {
          await localStorage.setItem( "link", "change_password" )
        }
        else {
          if( response.data.record.user_role === "APPLICANT" ) {
            await localStorage.setItem( "link", "welcome" )
          } 
          else if(response.data.record.user_role === "FINANCE"){
            await localStorage.setItem( "link", "finance" )
          }
          else {
            await localStorage.setItem( "link", "dashboard" )
          }
        }
        return window.location.reload()
      } else{
        alert("The credentials do not seem correct. Please try again")
        await setSigning( false )
      }
    } catch (error) {
      alert( "Your User Credentials may not correct." )
      await setSigning( false )
    }
  }

  const validatePassword = (password) => {
    const regex = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
    return regex.test(password);
  }

  const handleSubmitPassword = async ( values ) => {
    await setSigning( true )
    try {
      //console.log( 'values', values )
      if (validatePassword(values.password)) {
        if( values.password === values.confirm_password ) {
          const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/changePassword`, {
            password: values.password,
            id: localStorage.getItem( "userId" ),
            login_status: 1
          }  )
          if( response.data ) {
            alert( response.data.message )            
            await localStorage.setItem( "link", "welcome" )
            return window.location.reload()
          }
        }
        else {
          alert( "Passwords don't match" )
          await setSigning( false )
        }
      } else {
        alert( "Passwords must have atleast one Upper case, number and minimum of 8 characters" )
        await setSigning( false )
      }
      
      // if( response.data ){
      //   await localStorage.setItem( "email", response.data.record.email_address )
      //   await localStorage.setItem( "username", response.data.record.username )
      //   await localStorage.setItem( "role", response.data.record.user_role )
      //   if( response.data.record.login_status === 0 ) {
      //     await localStorage.setItem( "link", "change_password" )
      //   }
      //   else {
      //     await localStorage.setItem( "link", "welcome" )
      //   }
      //   return window.location.reload()
      // }
    } catch (error) {
        alert( "User not found." )
        await setSigning( false )
    }
  }

  const handleEmailChange = (event) => {
    setEmailValue(event.target.value);
  };

  const handleForgotPassword = async ( values ) => {
    await setSigning( true )
    try {
      if (emailValue === "") {
        alert("Please input your email and you will be sent a one time password on your email");
        await setSigning( false )
      } else {
        const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/forgot_password`, {
          email: emailValue,
          password: ""
        })
        
        if( response.data.otp ) {
          await setDisplayMessage( "An OTP has been sent to your email. Please use the sent password and your email to login" )
          alert("A one time password has been sent to your email. Use it to login");
          await setSigning( false )
          //return window.location.reload()
        }
      }
    } catch (error) {
      alert( error )
      await setSigning( false )
    }
  }

  return (
    <div className="w-screen h-screen overflow-x:hidden overflow-y-hidden md:overflow-y-hidden lg:overflow-y-hidden bg-gray-50">
        <TopBar home />
        <div className="w-full h-full flex items-start justify-center md:my-10 lg:my-10">
          <div className= "md:p-12 lg:p-12 p-5 lg:w-2/5 md:w-2/5 w-full h-auto bg-white rounded shadow-md mx-2">
            <div className="flex flex-col items-center justify-center">
              <div className="flex w-full items-center justify-center">
               <img src={NITALogo} alt="NITA Logo" className="w-auto" />
              </div>
              <h2 className="font-bold p-2 text-center">
                {`IT Certification`}
              </h2>
            </div>
            {/* <button type="button" className="bg-red-500 text-white text-base" onClick={() => getToken()}>
              {`Test Ughub`}
            </button> */}
            {changePassword ? (
            <>
              <h2 className="text-xs text-center">
                {`Change Your Password`}
              </h2>
              <Formik initialValues={{
                email: localStorage.getItem( "email" ),
                password: "",
                confirm_password: ""
            }} onSubmit={handleSubmitPassword}>
                { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                  return (
                      <form onSubmit={handleSubmit}>
                        <div className="w-full py-0 grid grid-cols-1">
                          <TextFieldIcon 
                            name="email"
                            type="email"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.email}
                            iconComponent={<FaUserAlt color={`#AFC836`} />} 
                            label="Email Address"
                            required={true}
                            disabled={true}
                            question="Email Address" />
                        </div>
  
                        <div className="w-full py-2 grid grid-cols-1">
                          <TextFieldIcon 
                            name="password"
                            type="password"
                            label="Password"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.password}
                            iconComponent={<FaLock color={`#AFC836`} />}
                            required={true}
                            disabled={signing}
                            question="Your Password (Must have an uppercase, lowercase, a special character)"
                          />

                          <TextFieldIcon 
                            name="confirm_password"
                            type="password"
                            label="Password"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.confirm_password}
                            iconComponent={<FaLock color={`#AFC836`} />}
                            required={true}
                            disabled={signing}
                            question="Confirm Your Password"
                          />
                        </div>
  
                        <div className="w-full py-2 grid grid-cols-1">
                            {signing ? (
                            <div className="flex items-center justify-center">
                              <CircularProgress size={24} color="primary" />
                            </div>
                            ):
                              ( <Button 
                                loading={isSubmitting} 
                                disabled={isSubmitting ? true : false} 
                                label={"Save"} /> )
                            }
                        </div>
                      </form>
                  )
                }  }
              </Formik>
            </>
            ) : (
            <Formik initialValues={{
              email: "",
              password: "",
            }} onSubmit={handleSubmit}>
                { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                  return (
                      <form autocomplete={true} onSubmit={handleSubmit}>
                        <div className="w-full py-0 grid grid-cols-1">
                          <TextFieldIcon 
                            name="email"
                            type="text"
                            handleChange={evt => {
                              handleChange(evt)
                              handleEmailChange( evt)
                            }}
                            handleBlur={handleBlur}
                            value={values.email}
                            iconComponent={<FaUserAlt color={`#AFC836`} />} 
                            label="Email"
                            required={true}
                            disabled={signing}
                            question="Email" />
                        </div>
  
                        <div className="w-full py-2 grid grid-cols-1">
                          <TextFieldIcon 
                            name="password"
                            type="password"
                            label="Password"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.password}
                            iconComponent={<FaLock color={`#AFC836`} />}
                            required={true}
                            disabled={signing}
                            question="Your Password"
                          />
                        </div>
  
                        <div className="w-full py-2 grid grid-cols-1">
                            {signing ? (
                            <div className="flex items-center justify-center">
                              <CircularProgress size={24} color="primary" />
                            </div>
                            ):
                              ( 
                              <Button 
                                loading={isSubmitting} 
                                disabled={isSubmitting ? true : false} 
                                label={"Login"} /> 
                              )
                            }
                            <a className="text-blue-700 hover:cursor-pointer" onClick={handleForgotPassword}>Forgot password?</a>
                        </div>

                        <div className="grid grid-cols-1 gap-2 my-5 border border-gray-100" onClick={handleSubmitUgPassSASignIn}>
                          <button type="button" className="flex items-center justify-center rounded bg-white shadow-md py-1">
                            <span className="font-bold text-base mx-2">{`Login with`}</span>
                            <img src={UGPassLogo} className="h-8"/>
                          </button>
                        </div>

                        <div className="displayMessage text-blue-500 text-lg">{displayMessage}</div>
                      </form>
                  )
                }  }
            </Formik> ) }
          </div>
        </div>
        <div> 
        </div>
      </div>
  )
}

export const Footer = () => {
  return (
    <div className="flex items-center justify-center absolute h-12 sm:h-14 md:h-20 lg:h-20 bottom-0 left-0 w-full bg-white">
      <div>
        <span className="text-xs">{`Terms of Use Limitation of Liability Privacy Policy`}</span>
      </div>
      <div className="px-2">
        <span className="text-xs">{`Copyright`}</span>
      </div>
    </div>
  )
}

